module.exports = __webpack_public_path__ + "img/singapore.6429d780.svg";